var moduleMap = {
	"./Title": function() {
		return Promise.all([__webpack_require__.e(541), __webpack_require__.e(3457), __webpack_require__.e(2277), __webpack_require__.e(3689)]).then(function() { return function() { return (__webpack_require__(63689)); }; });
	},
	"./ProductEditor": function() {
		return Promise.all([__webpack_require__.e(541), __webpack_require__.e(499), __webpack_require__.e(3457), __webpack_require__.e(6764), __webpack_require__.e(2277), __webpack_require__.e(9634), __webpack_require__.e(2708), __webpack_require__.e(3863), __webpack_require__.e(3689), __webpack_require__.e(7058), __webpack_require__.e(6960), __webpack_require__.e(6665)]).then(function() { return function() { return (__webpack_require__(26665)); }; });
	},
	"./LessonEditor": function() {
		return Promise.all([__webpack_require__.e(541), __webpack_require__.e(2071), __webpack_require__.e(3560), __webpack_require__.e(499), __webpack_require__.e(3457), __webpack_require__.e(6764), __webpack_require__.e(3969), __webpack_require__.e(2277), __webpack_require__.e(2708), __webpack_require__.e(3894), __webpack_require__.e(5849), __webpack_require__.e(3863), __webpack_require__.e(3689), __webpack_require__.e(1232), __webpack_require__.e(7058), __webpack_require__.e(3594)]).then(function() { return function() { return (__webpack_require__(13594)); }; });
	},
	"./highlightDirective": function() {
		return __webpack_require__.e(2327).then(function() { return function() { return (__webpack_require__(32327)); }; });
	},
	"./i18n": function() {
		return Promise.all([__webpack_require__.e(541), __webpack_require__.e(3457), __webpack_require__.e(5500), __webpack_require__.e(6014)]).then(function() { return function() { return (__webpack_require__(36014)); }; });
	},
	"./store": function() {
		return Promise.all([__webpack_require__.e(541), __webpack_require__.e(3457), __webpack_require__.e(3863)]).then(function() { return function() { return (__webpack_require__(63863)); }; });
	},
	"./remoteRouter": function() {
		return Promise.all([__webpack_require__.e(541), __webpack_require__.e(3457), __webpack_require__.e(8616)]).then(function() { return function() { return (__webpack_require__(28616)); }; });
	},
	"./vue3": function() {
		return Promise.all([__webpack_require__.e(2806), __webpack_require__.e(541), __webpack_require__.e(504)]).then(function() { return function() { return (__webpack_require__(17527)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});